import { render, staticRenderFns } from "./Export2.vue?vue&type=template&id=d60d6d7c&scoped=true&"
import script from "./Export2.vue?vue&type=script&lang=ts&"
export * from "./Export2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60d6d7c",
  null
  
)

export default component.exports